
<template>
    <v-app id="searchAkcd">
        <v-main>
            <v-container fluid>  
                <v-card>
                    <v-card-title>Action codes  <v-spacer></v-spacer><v-btn class="primary ma-2" x-small @click="addAkcd()">Add Discount code</v-btn></v-card-title>
                    <v-simple-table>
                        <tbody v-for="(akcdRecord,i) in searchAkcd" :key="i">
                            <tr>
                                <td>{{akcdRecord.akcd_nr}}</td>
                                <td>{{akcdRecord.akcd_oms}}</td>
                                <td>Unique Codes: {{akcdRecord.akcd_unique_akcc}}</td>
                                <td>{{akcdRecord.akcd_verk_kort}}</td>
                                <td>Companies: {{akcdRecord.bedr_codes}}</td>
                                <td>Countries: {{akcdRecord.land_codes}}</td>
                                <td>{{akcdRecord.akcd_boek_bedrag}}</td>
                                <td><v-btn text icon  @click="rmAkcd(akcdRecord.akcd_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                                <td><v-btn class="primary ma-2" x-small @click="addAkpr(akcdRecord.akcd_encrid)">Add rule</v-btn></td>
                                <td><v-btn class="primary ma-2" x-small @click="addAkcc(akcdRecord.akcd_encrid)">Add Code</v-btn></td>
                            </tr>
                            <!-- <tr>
                                <td>{{akcdRecord.akcd_nr}}</td>
                                <td colspan=3>{{akcdRecord.akcd_oms}}</td>
                                <td>{{akcdRecord.akcd_verk_kort}}</td>
                                <td>{{akcdRecord.akcd_boek_bedrag}}</td>
                                <td><v-btn text icon  @click="rmAkcd(akcdRecord.akcd_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                                <td><v-btn class="primary ma-2" x-small @click="addAkpr(akcdRecord.akcd_encrid)">Add rule</v-btn></td>
                                <td><v-btn class="primary ma-2" x-small @click="addAkcc(akcdRecord.akcd_encrid)">Add Code</v-btn></td>
                            </tr>                            
                            <tr>
                                <td></td>
                                <td>Unique Codes: {{akcdRecord.akcd_unique_akcc}}</td>
                                <td>Acco Companies: {{akcdRecord.bedr_codes}}</td>
                                <td>Acco Countries: {{akcdRecord.land_codes}}</td>
                                <td colspan=5></td>
                            </tr> -->
                            <tr>
                                <td></td>
                                <td colspan=9>
                                    <table>    
                                        <tr v-for="(akprRecord,j) in akcdRecord.akpr" :key="j">
                                            <!--
                                            <td>{{akprRecord.akpr_verb}}</td>
                                            <td>{{akprRecord.akpr_boek}}</td>
                                            <td>{{akprRecord.akpr_advb}}</td>
                                            <td>{{akprRecord.akpr_aant_nacht}}</td>
                                            <td>{{akprRecord.akpr_dag}}</td>
                                            -->
                                            <td>{{akprRecord.akpr_regel}}</td>
                                            <td><v-btn text icon  @click="rmAkpr(akprRecord.akpr_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                                        </tr>
                                    </table>
                                </td>   
                            </tr>
                            <tr>
                                <td></td>
                                <td colspan=9>{{akcdRecord.akcd_akcc}}</td>   
                            </tr>   
                            <tr><td colspan=10><hr></td></tr>           
                        </tbody>  
                    </v-simple-table>
                    <rmAkcd ref="rmAkcd"></rmAkcd>  
                    <addAkpr ref="addAkpr"></addAkpr> 
                    <addAkcd ref="addAkcd"></addAkcd>
                    <rmAkpr ref="rmAkpr"></rmAkpr> 
                    <addAkcc ref="addAkcc"></addAkcc>   
                </v-card>  
            </v-container>
        </v-main>
        <navBar title="Ares - Reference data" :home="true" type="referencedata"/>    
    </v-app>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import addAkpr from "@/views/syst/ref/akcd/addAkpr";
    import addAkcd from "@/views/syst/ref/akcd/addAkcd";
    import rmAkcd from "@/views/syst/ref/akcd/rmAkcd";
    import rmAkpr from "@/views/syst/ref/akcd/rmAkpr";
    import addAkcc from "@/views/syst/ref/akcd/addAkcc";
    
    export default {
        components: {
            navBar,
            addAkcd,
            addAkpr,
            rmAkcd,
            rmAkpr,
            addAkcc
        },
        data() {
            return {
                headers: [
                    {text: 'Discount name'},
                    {text: ''},
                    {text: ''},
                    {text: ''},
                    {text: ''},
                    {text: ''},
                    {text: ''},
                    {text: ''},
                    {text: ''},
                ],
                searchAkcd: [],
            }  
        },
        mounted() {
            this.$axios.post("ares/json/ares/syst/ref/akcd/searchAkcd.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "searchAkcd"
                },
                searchAkcd: {
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.searchAkcd = res.data.searchAkcd;
                }
            });
        },
        methods: {
            rmAkcd(akcd_encrid) {
                this.$refs.rmAkcd.open(akcd_encrid);
            },
            addAkpr(akcd_encrid) {
                this.$refs.addAkpr.open(akcd_encrid);
            },
            rmAkpr(akpr_encrid) {
                this.$refs.rmAkpr.open(akpr_encrid);
            },
            addAkcd() {
                this.$refs.addAkcd.open();
            },
            addAkcc(akcd_encrid) {
                this.$refs.addAkcc.open(akcd_encrid);
            },
        }
    };
</script> 
